import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'

const HeaderSocials = () => {
  return (
    <div className='header_socials'>
        <a href="https://www.linkedin.com/in/caden-smith-7806a3223/" target="_blank"><BsLinkedin/></a>
        <a href="https://github.com/Cadensmith1123" target="_blank"><BsGithub /></a>
        <a href="https://twitter.com/Boreinc23" target="_blank"><BsTwitter/></a>
    </div>
  )
}

export default HeaderSocials